import { createContext, use } from 'react';
import invariant from 'tiny-invariant';

import type { ModelWithNetStats } from '@cadstrom/sigma-engine-shared';

export type CoreModelContextValue = {
	coreModel: ModelWithNetStats;
};

export const CoreModelContext = createContext<CoreModelContextValue | null>(null);
export function useCoreModelContext(required?: true): CoreModelContextValue;
export function useCoreModelContext(required: false): CoreModelContextValue | undefined;
export function useCoreModelContext(required = true): CoreModelContextValue | undefined {
	const value = use(CoreModelContext);
	invariant(Boolean(value) || !required, 'CoreModelContext is not provided');
	return value!;
}
